import { CampaignTemplateType, } from "@kvix/shared";
import React from "react";
import { Redirect } from "react-router";
export class DefaultTemplate {
    constructor() {
        this.defaultStructure = null;
        this.campaignTemplateType = CampaignTemplateType.Default;
        this.Render = (props) => {
            return React.createElement(Redirect, { to: "/" });
        };
        this.Compose = (props) => {
            return null;
        };
    }
}
//# sourceMappingURL=DefaultTemplate.js.map